import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {BrandLogoHollow} from '@modifi/ui'
import {white} from '@modifi/colors'
import {Link} from '@modifi/router'
import {CnBrandLogo, CnBrandLogoHollow} from '../../../../../assets/graphics/cn-brand-logo'
import {LogoWidth, LogoHeight} from '../../styles'
import {useCurrentRegion} from '../../../../../features/route-info'

const propTypes = {
  isTransparent: PropTypes.bool,
  homeUrl: PropTypes.string,
  isDisplayedOnMobile: PropTypes.bool,
  handleNavItemClick: PropTypes.func,
}
const defaultProps = {
  isTransparent: false,
  homeUrl: undefined,
  isDisplayedOnMobile: false,
  handleNavItemClick: () => null,
}

export type CountryAwareBrandLogoProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const CountryAwareBrandLogo: React.FC<CountryAwareBrandLogoProps> = ({
  isTransparent,
  homeUrl,
  isDisplayedOnMobile,
  handleNavItemClick,
}) => {
  const region = useCurrentRegion()
  switch (region) {
    case 'cn':
      return isTransparent ? (
        <Link to={homeUrl} onClick={handleNavItemClick}>
          <CnBrandLogoHollow
            width={isDisplayedOnMobile ? LogoWidth / 2 : LogoWidth}
            height={LogoHeight}
          />
        </Link>
      ) : (
        <Link to={homeUrl} onClick={handleNavItemClick}>
          <CnBrandLogo
            width={isDisplayedOnMobile ? LogoWidth / 2 : LogoWidth}
            height={LogoHeight}
          />
        </Link>
      )
    default:
      return (
        <Link to={homeUrl} onClick={handleNavItemClick}>
          <BrandLogoHollow
            boxColor={isTransparent ? white : null}
            width={LogoWidth}
            height={LogoHeight}
          />
        </Link>
      )
  }
}

CountryAwareBrandLogo.propTypes = propTypes
CountryAwareBrandLogo.defaultProps = defaultProps

export default CountryAwareBrandLogo
